export default __webpack_public_path__ + "img/e1fe913cc581ddb1c2749e069dcec4e3.png";